import Fuse from 'fuse.js';
import { Injectable } from '@angular/core';
import { cloudTopics } from './data/cloudTopics';
import { cloudStorageTopics } from './data/cloudStorageTopics';
import { webHostingTopics } from './data/webHostingTopics';
import { gameServerTopics } from './data/gameServerTopics';

import { backupTopics } from './data/backupTopics';
import { serverManagementTopics } from './data/serverManagementTopics';
import { databaseTopics } from './data/databaseTopics';

@Injectable({
  providedIn: 'root',
})

export class SearchService {
  private services = [
    { name: 'Cómputo en la Nube', icon:"fa-solid fa-cloud", route:"/services/cloud-computing", keywords: cloudTopics},
    { name: 'Almacenamiento en la Nube', icon:"fa-solid fa-hard-drive", route:"/services/cloud-storage", keywords: cloudStorageTopics},
    { name: 'Hosting Especializado', icon:"fa-solid fa-server", route:"/services/dedicated-hosting", keywords: webHostingTopics },
    { name: 'Servidores para videojuegos', icon:"fa-solid fa-gamepad", route:"/services/gaming-servers", keywords:  gameServerTopics},
    { name: 'Resguardo de Datos', icon:"fa-solid fa-file-shield", route:"/services/intermediate-data-protection", keywords:  backupTopics},
    { name: 'Administración de Equipos', icon:"fa-solid fa-screwdriver-wrench", route:"/services/equipment-administration", keywords: serverManagementTopics },
    { name: 'Alojamiento Base de Datos', icon:"fa-solid fa-database", route:"/services/dedicated-database", keywords: databaseTopics }
  ];

  private fuse = new Fuse(this.services, {
    keys: ['name', 'keywords'],
    threshold: 0.3,
    shouldSort: false,
  });

  search(query: string) {
    if (!query.trim()) return [];

    const terms = query.toLowerCase().split(' ');

    let resultsMap = new Map();

    for (const term of terms) {
      const searchResults = this.fuse.search(term);
      for (const result of searchResults) {
        const service = result.item;
        const existing = resultsMap.get(service.name) || { service, count: 0 };
        existing.count++;
        resultsMap.set(service.name, existing);
      }
    }

    return Array.from(resultsMap.values())
      .sort((a, b) => b.count - a.count)
      .map(entry => entry.service);
  }
}
